import Delegate from "//www.feed.co/cdn/shop/t/8/assets/ftdomdelegate.min.js?v=85864865866317895671734605445";
import {ToggleElem} from "//www.feed.co/cdn/shop/t/8/assets/helpers.js?v=132700998466281914211734605445";
export class LandingVideoSection extends HTMLElement {

  connectedCallback() {
    this._attachListeners();
  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="toggle-video"]', this._toggleVideo.bind(this));
  }

  /**
   * Toggle video
   */
  _toggleVideo(e, target) {
    if (e) e.preventDefault();

    let videoContainer = this.querySelector('#'+target.getAttribute('aria-controls'));
    let video = videoContainer.querySelector('video');
    let videoPaused = video.paused;

    if (video){
      if (videoPaused) {
        video.play();
      } else {
        video.pause();
      }
      ToggleElem.toggleElement(e, target, 'overlay');
    }
  }

}
try {
  window.customElements.define('landing-video-section', LandingVideoSection);
} catch(e) {}